'use client'

import { useEffect } from 'react'

export default function ScrollToRegistration({ enabled }: { enabled: boolean }) {
  useEffect(() => {
    if (!enabled) return

    let cancelled = false
    const startedAt = Date.now()
    const maxWaitMs = 2500

    const attempt = () => {
      if (cancelled) return
      const el = document.getElementById('registration-form')
      if (!el) {
        if (Date.now() - startedAt < maxWaitMs) {
          window.requestAnimationFrame(attempt)
        }
        return
      }

      const top = Math.max(0, el.getBoundingClientRect().top + window.scrollY - 80)
      try {
        window.scrollTo({ top, behavior: 'smooth' })
      } catch {
        el.scrollIntoView()
      }
    }

    window.requestAnimationFrame(attempt)
    return () => {
      cancelled = true
    }
  }, [enabled])

  return null
}
